import { useMutation } from '@tanstack/react-query'
import type { AdminBootstrapInput } from '../api'
import type { IMutationArgs } from '../types'
import { adminBootstrapOptions } from './admin-bootstrap.options'
import { EAdminBootstrapQueryKey } from './admin-bootstrap.types'

export const useAdminBootstrap = (args: IMutationArgs) => {
  return useMutation({
    mutationFn: (data: AdminBootstrapInput) =>
      adminBootstrapOptions(data).mutationFn(data),
    mutationKey: [EAdminBootstrapQueryKey.ADMIN_BOOTSTRAP],
    onSuccess: (data) => {
      return data
    },
  })
}
